import { CKButton, CKMultilineTextFieldNext, CKTextFieldNext } from 'clearkit';
import { isEqual } from 'lodash';
import { FC, useState } from 'react';

import { ButtonContainer } from '~/components/unified/ButtonContainer';
import { SettingsCard } from '~/components/unified/SettingsCard';
import { BillingInfo } from '~/generated/graphql';

type FormBillingDetailsProps = {
  onChange: (value: BillingInfo) => void;
  value: BillingInfo;
};

export const FormBillingDetails: FC<FormBillingDetailsProps> = ({
  onChange,
  value,
}) => {
  const [billingDetailsData, setBillingDetailsData] = useState<BillingInfo>(
    value,
  );

  const handleSave = () => {
    onChange(billingDetailsData);
  };

  const isDirty = !isEqual(billingDetailsData, value);

  return (
    <SettingsCard>
      <SettingsCard.Header>
        <SettingsCard.Heading>Billing Details</SettingsCard.Heading>
      </SettingsCard.Header>
      <SettingsCard.Body className="grid gap-6">
        <CKTextFieldNext
          onChange={(newValue) => {
            setBillingDetailsData((prevState) => ({
              ...prevState,
              billingName: newValue,
            }));
          }}
          placeholder="Team name"
          value={billingDetailsData?.billingName || ''}
        >
          <CKTextFieldNext.Label>Team name</CKTextFieldNext.Label>
        </CKTextFieldNext>
        <CKTextFieldNext
          onChange={(newValue) => {
            setBillingDetailsData((prevState) => ({
              ...prevState,
              billingEmail: newValue,
            }));
          }}
          type="email"
          value={billingDetailsData?.billingEmail || ''}
        >
          <CKTextFieldNext.Label>Billing email</CKTextFieldNext.Label>
        </CKTextFieldNext>
        <CKMultilineTextFieldNext
          onChange={(newValue) => {
            setBillingDetailsData((prevState) => ({
              ...prevState,
              address: newValue,
            }));
          }}
          value={billingDetailsData?.address || ''}
        >
          <CKMultilineTextFieldNext.Label>
            Address
          </CKMultilineTextFieldNext.Label>
        </CKMultilineTextFieldNext>
      </SettingsCard.Body>
      <SettingsCard.Footer className="flex justify-end">
        <ButtonContainer>
          <CKButton
            isDisabled={!isDirty}
            onClick={() => setBillingDetailsData(value)}
            variant="simple"
          >
            Discard changes
          </CKButton>
          <CKButton
            isDisabled={!isDirty}
            onClick={handleSave}
            variant="bold"
            variantColor="blue"
          >
            Save changes
          </CKButton>
        </ButtonContainer>
      </SettingsCard.Footer>
    </SettingsCard>
  );
};
